import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import GarageIcon from "@mui/icons-material/Build";
import CustomersIcon from "@mui/icons-material/People";
import RatingIcon from "@mui/icons-material/StarRate";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const InfoCard = ({ icon: Icon, title, value, isDecimal = false, triggerCount }) => (
  <Card
    sx={{
      minWidth: { xs: 160, sm: 180 },
      padding: 2,
      borderRadius: 3,
      backgroundColor: "#f9f9f9",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      mx: { xs: 1, md: 0 },
      mb: { xs: 0, md: 0 },
    }}
  >
    <Icon sx={{ fontSize: 32, color: "orangeRed", mb: 1 }} />
    <Typography variant="h6" fontWeight="bold" color="black">
      <CountUp
        end={value}
        duration={2}
        decimals={isDecimal ? 1 : 0}
        suffix={title === "Social Media Ratings" ? "/5" : "+"}
        start={triggerCount}
        redraw={true}
      />
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {title}
    </Typography>
  </Card>
);

const MetricsDisplay = () => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <Box
      ref={ref}
      sx={{
        px: 2,
        py: 4,
        backgroundColor: "white",
      }}
    >
      <Typography
        variant="h5"
        textAlign="center"
        fontWeight="bold"
        color="orangeRed"
        mb={3}
      >
        Our Achievements
      </Typography>

      {/* Hint text for mobile */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          textAlign: "center",
          color: "gray",
          fontSize: "13px",
          mb: 1,
        }}
      >
        Swipe to see more →
      </Box>

      {/* Card container */}
      <Box
        sx={{
          display: { xs: "flex", md: "grid" },
          gridTemplateColumns: { md: "repeat(3, 1fr)" },
          gap: { md: 4 },
          overflowX: { xs: "auto", md: "unset" },
          px: { xs: 1, md: 0 },
          position: "relative",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {/* Scroll shadow hint */}
        <Box
          sx={{
            display: { xs: "block", md: "none" },
            position: "absolute",
            right: 0,
            top: 0,
            width: 40,
            height: "100%",
            background:
              "linear-gradient(to left, white 10%, rgba(255,255,255,0))",
            pointerEvents: "none",
            zIndex: 1,
          }}
        />
        <InfoCard
          icon={GarageIcon}
          title="Total Garages"
          value={150}
          triggerCount={inView}
        />
        <InfoCard
          icon={CustomersIcon}
          title="Happy Customers"
          value={10000}
          triggerCount={inView}
        />
        <InfoCard
          icon={RatingIcon}
          title="Social Media Ratings"
          value={4.8}
          isDecimal={true}
          triggerCount={inView}
        />
      </Box>
    </Box>
  );
};

export default MetricsDisplay;
